import { AfterViewChecked, AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[paceCoreTabsRole]',
})
export class TabsRoleDirective implements AfterViewInit, AfterViewChecked {
    public constructor(
        private readonly el: ElementRef<HTMLElement>,
        private readonly renderer: Renderer2,
    ) {}

    /* This function is being used to remove the role attribute for <ul> and <a> tags inside <tabset> element.
    We are using tabset from ngx-bootstrap library, where the roles have not been added correctly to the list elements.
    As per WCAG, if a parent element(<ul>) has role: 'tablist', then the child elements must have roles: 'tab'.
    But in case of tabset, instead of adding roles: 'tab' to child elements(<li>),
    they have added it inside the child element(<li><a>).
     */

    public ngAfterViewInit(): void {
        const ulElement = this.el.nativeElement.children[0];
        const listElements = ulElement.children;
        this.renderer.removeAttribute(ulElement, 'role');

        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < listElements.length; i++) {
            const anchorElement = listElements[i].children[0];
            this.renderer.removeAttribute(anchorElement, 'role');
            this.renderer.removeAttribute(anchorElement, 'aria-selected');
        }
    }

    public ngAfterViewChecked(): void {
        const listElements = this.el.nativeElement.children[0].children;

        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < listElements.length; i++) {
            const anchorElement = listElements[i].children[0];
            this.renderer.removeAttribute(anchorElement, 'aria-selected');
        }
    }
}
